import { render } from "./h-help.vue?vue&type=template&id=78fe58d2&scoped=true"
import script from "./h-help.vue?vue&type=script&lang=js"
export * from "./h-help.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fe58d2"]])

export default __exports__